import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function ArrowDownIcon({ color = "offWhite" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M17.834 10L12.834 15L7.83398 10"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
